// GitHub accounts shown in the contribution calendar. Their activity is merged
// into one graph; add as many as you like. `label` appears in the legend and
// tooltips.
//
// Private (e.g. company) work is only counted if that account enables
// "Private contributions" in its GitHub profile settings.
const githubAccounts = [
  { username: "vigneshwarancsk", label: "Work" },
  { username: "Vickeysvibe", label: "Personal" },
];

export default githubAccounts;
